/**
 * Created by ok on 6/11/16.
 */
import * as types from '../actions/actionTypes.js';
import {parseToHsl} from './../helper/ColorUtils';

const colorPicker = ( state, action ) => {

    switch ( action.type ) {

        case types.COLORS_RESETTED:
            return state;

        case types.UI_SWATCH_SELECTED:
            return Object.assign( {}, state, {color: parseToHsl(action.color) } );

        default:
            return state;
    }
};

export default colorPicker

export const getPickerColor = state => state.stolo.colorpicker.color;




// WEBPACK FOOTER //
// ./src/reducers/colorpicker.js